import React, { useState, useEffect } from "react";
import {storage} from "../../firebase";
import Loading from "../../components/Loading/Loading";
import "./css/PdfCss.css"

export default function PdfPreview(src) {
    const [url, setUrl] = useState(null);
    const [LoadingScreen, setLoadingScreen] = useState(false);

    console.log(localStorage.getItem("file"))
    console.log(localStorage.getItem('user_uid'))

    useEffect(() => {
        setLoadingScreen(true);
        const firebasedDownloadURL = storage.ref().child(localStorage.getItem('user_uid') + '/' + localStorage.getItem("file"))
            .getDownloadURL()
            .then((url) => {
              setUrl(url);
              setLoadingScreen(false);
            });
        return () => firebasedDownloadURL;
    }, []);

    if(LoadingScreen) {
        return(
            <Loading />
        )
    }

    return (
        <object data={url} type="application/pdf">
            <embed src={url} type="application/pdf" />
        </object>
    );
}